<main class="w-full">
	<div class="w-full h-[40px] flex flex-row relative">
		@if (value) {
			<div class="grow flex justify-center flex-col">
				<div
					class="flex items-center h-[10px] justify-center text-center text-xs whitespace-nowrap h-[22px] w-[120px] rounded flex items-center justify-center text-gray-50"
					[ngClass]="status[type][value]?.color || 'bg-gray-800'"
				>
					{{ status[type][value]?.label || value }}
				</div>
			</div>
		}
	</div>
</main>
